import React from 'react'
import { Link } from 'react-router-dom'

const BreadCrumb = ( {items} ) => {
  return (
    <nav className="text-gray-600 text-sm font-bold" aria-label="breadcrumb">
    <ol className="flex items-center space-x-2 ml-10">
      {items.map((item, index) => (
        <li key={index} className="flex items-center">
          {index !== 0 && <span className="mx-2">/</span>}
          {item.href ? (
            <Link to={item.href} className="text-[#303030] hover:none">
              {item.label}
            </Link>
          ) : (
            <span className="text-gray-500">{item.label}</span>
          )}
        </li>
      ))}
    </ol>
  </nav>
  )
}

export default BreadCrumb
